import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';



@Injectable({providedIn: 'root'})
export class ObservableKeyValueStoreService {
  private store$ = new BehaviorSubject<{[id: string]: any}>({});

  getItem(key: string): Observable<any> {
    return this.store$.asObservable().pipe(pluck(key));
  }

  setItem(key: string, value: any) {
    this.store$.next({...this.store$.getValue(), [key]: value});
  }

  removeItem(key: string) {
    const {[key]: removed, ...rest} = this.store$.getValue();
    this.store$.next({...rest});
  }

  resetStore() {
    this.store$.next({});
  }
}
